export function formatDate(date: string | undefined) {
  return date?.split("T")[0];
}

export function getCurrentDateInISO() {
  return new Date().toISOString().split("T")[0];
}
